// extracted by mini-css-extract-plugin
module.exports = {"rows":"styles_rows__1JwiV","single":"styles_single__2aBb8"};